module.exports = __webpack_public_path__ + "media/images/macFFBgHack-f412d72fe643d6fee70e06368b0fa873.png";